'use strict';

function EmailToObjectCtrl(
  $scope,
  groups,
  CompanyUserService,
  $stateParams) {
  $scope.groups = groups;

  var nonWatchersPromise;
  $scope.nonWatchers             = [];
  $scope.updateNonWatchers = function(filter, watchers) {   
    var p = CompanyUserService.query({
        companyId: $stateParams.companyId,
        q: filter,
        limit: 10}).$promise.then(function(users) {
      return users.filter(function(item) {
        return !watchers.some(function(watcher) {
          return item.id === watcher.id;
        });
      });
    }).then(function(nonWatchers) {
      if(nonWatchersPromise === p) {
        $scope.nonWatchers = nonWatchers;
      }
    });
    
    nonWatchersPromise = p;
  };

  $scope.addWatcher = function(item, watchers) {
    watchers.push(item);
    $scope.nonWatchers.splice($scope.nonWatchers.indexOf(item), 1);
  };
}

EmailToObjectCtrl.resolve = {
  groups: ['$stateParams', 'CompanyGroupService', function ($stateParams, CompanyGroupService) {
    return CompanyGroupService.query({
      companyId: $stateParams.companyId,
      all: true
    }).$promise;
  }]
};

module.exports = EmailToObjectCtrl; 
angular.module('dokiv')
  .controller('EmailToObjectCtrl', [
    '$scope',
    'groups',
    'CompanyUserService',
    '$stateParams',
    EmailToObjectCtrl]);


//////////////////
// WEBPACK FOOTER
// ./scripts/company/email-to-object/EmailToObjectCtrl.js
// module id = 341
// module chunks = 0